<template>
  <div class="patient-detail-scrolling-wrapper">
    <v-data-table
      v-show="loadingExams || exams.length"
      :value="selectedExams"
      @input="selectExams"
      :headers="headers"
      :items="exams"
      :items-per-page="-1"
      item-key="exSrNo"
      sort-by="dateIso"
      :sort-desc="true"
      :loading="loadingExams"
      :expanded.sync="expanded"
      show-select
      hide-default-footer
      class="patient-detail-wrapper small-checkbox primary">
      <template slot="header.download">
        <v-hover v-if="canDownloadExam">
          <v-btn
            icon
            slot-scope="{ hover }"
            class="exambtn"
            @click.stop="$store.dispatch('generateExamZipForChecked', exams)">
            <img v-if="hover" 
              :src="require('../../assets/' + coloredAssetUrls.download)" 
              class="patientDetailTableIcon" />
            <img v-else 
              :src="require('../../assets/' + coloredAssetUrls.patientDownload)" 
              class="patientDetailTableIcon" />
          </v-btn>
        </v-hover>
      </template>
      <template slot="header.editExam">
        <img v-if="canEditPathology"
          :src="require('../../assets/' + coloredAssetUrls.patientPencil)" 
          class="patientDetailTableIcon pencilIcon"/>
      </template>
      <template slot="header.delete">
        <v-hover v-if="canDelete">
          <v-btn
            icon
            @click.stop="$store.commit('addExamToDeleteList', selectedExams)"
            slot-scope="{ hover }"
            class="exambtn">
            <img v-if="hover" :src="require('../../assets/' + coloredAssetUrls.clear)" class="patientDetailTableIcon" />
            <img v-else :src="require('../../assets/' + coloredAssetUrls.patientTrash)"  class="patientDetailTableIcon" />
          </v-btn>
        </v-hover>
        <!-- <img src="../../assets/Delete - White.png" class="patientDetailTableIcon delete" /> -->
      </template>
      <template slot="item" slot-scope="props">
        <tr :active="props.isSelected" @click="props.expand(!props.isExpanded)">
          <td class="exam-checkbox">
            <v-checkbox
              :color="colorHex"
              :input-value="props.isSelected"
              primary
              hide-details
              @click.stop="selectExam(props, props.item)"/>
              <span class="tooltiptext">{{props.item.exSrNo}}</span>
          </td>
          <td>
            <img
              v-if="props.item.exDict"
              :src="require('../../assets/' + coloredAssetUrls.microphone)"
              class="patientDetailTableIcon"/>
            <img v-else :src="require('../../assets/' + coloredAssetUrls.patientMic)" class="patientDetailTableIcon" />
          </td>
          <td>
            <img
              v-if="props.item.exIsStudy"
              :src="require('../../assets/' + coloredAssetUrls.teachingResearch)"
              class="patientDetailTableIcon"/>
            <img
              v-else
              :src="require('../../assets/' + coloredAssetUrls.patientTeaching)"
              class="patientDetailTableIcon"/>
          </td>
          <td>{{props.item.dateDisplay}}</td>
          <td>{{props.item.exEye}}</td>
          <td>{{props.item.exDevice}}</td>
          <td class="d-none d-lg-table-cell">
            <span v-if="props.item.firstMD.length > 0" class="phyicianTooltip">
              <img :src="require('../../assets/' + coloredAssetUrls.physician)" class="patientDetailTableIcon physicianBlue">
              <span v-if="props.item.exAttdMDHtml.length > 0">
                <span v-for="(item, index) in props.item.exAttdMDHtml" :key="item">
                  <span v-if="index != Object.keys(props.item.exAttdMDHtml).length - 1">{{item}},&nbsp;</span>
                  <span v-else>{{item}}</span>
                </span>
              </span>
              <span v-if="props.item.exRefMDHtml.length > 0 && props.item.exAttdMDHtml.length > 0">&nbsp;</span>
              <span v-if="props.item.exRefMDHtml.length > 0">
                <span v-for="(item, index) in props.item.exRefMDHtml" :key="item" class="referringMD">
                  <span v-if="index != Object.keys(props.item.exRefMDHtml).length - 1">{{item}},&nbsp;</span>
                  <span v-else>{{item}}</span>
                </span>
              </span>
              <span class="tooltiptext">
                <span v-if=" props.item.exAttdMDHtml.length > 0">
                  Attending :&nbsp;
                  <span v-for="(item, index) in props.item.exAttdMDHtml" :key="item">
                    <span v-if="index != Object.keys(props.item.exAttdMDHtml).length - 1">{{item}},&nbsp;</span>
                    <span v-else>{{item}}</span>
                  </span>
                </span>
                <span v-if="props.item.exRefMDHtml.length > 0 && props.item.exAttdMDHtml.length > 0">&nbsp;</span>
                <span v-if="props.item.exRefMDHtml.length > 0">
                  &#40;Referring :&nbsp;
                  <span v-for="(item, index) in props.item.exRefMDHtml" :key="item">
                    <span v-if="index != Object.keys(props.item.exRefMDHtml).length - 1">{{item}},&nbsp;</span>
                    <span v-else>{{item}}</span>
                  </span>
                  &#41;
                </span>
              </span>
            </span>
            <img v-else :src="require('../../assets/' + coloredAssetUrls.patientPhysician)" class="patientDetailTableIcon">
          </td>
          <td class="d-none d-lg-table-cell">
            <img
              v-if="props.item.exPathology"
              :src="require('../../assets/' + coloredAssetUrls.diagnosis)"
              class="patientDetailTableIcon"/>
            <img v-else :src="require('../../assets/' + coloredAssetUrls.patientDiagnosis)" class="patientDetailTableIcon" />
            {{props.item.exPathology}}
          </td>
          <td>
            <v-hover v-if="canDownloadExam">
              <v-btn
                icon
                slot-scope="{ hover }"
                class="exambtn"
                @click.stop="$store.dispatch('generateExamZip', props.item)">
                <img
                  v-if="hover"
                  :src="require('../../assets/' + coloredAssetUrls.download)"
                  class="patientDetailTableIcon"/>
                <img v-else :src="require('../../assets/' + coloredAssetUrls.patientDownload)" class="patientDetailTableIcon" />
              </v-btn>
            </v-hover>
          </td>
          <td :class="emrproClass()">
            <v-hover v-if="canEditPathology">
              <v-btn
                icon
                slot-scope="{ hover }"
                class="exambtn"
                @click.stop="$emit('open', props.item)">
                <img
                  v-if="hover"
                  :src="require('../../assets/' + coloredAssetUrls.editPathology)"
                  class="patientDetailTableIcon"/>
                <img
                  v-else
                  :src="require('../../assets/' + coloredAssetUrls.patientPencil)"
                  class="patientDetailTableIcon"/>
              </v-btn>
            </v-hover>
          </td>
          <td :class="emrproClass()">
            <v-hover v-if="canDelete">
              <v-btn
                icon
                @click.stop="$store.commit('setExamToDelete', props.item)"
                slot-scope="{ hover }"
                class="exambtn">
                <img v-if="hover" 
                  :src="require('../../assets/' + coloredAssetUrls.clear)"
                  class="patientDetailTableIcon" />
                <img v-else :src="require('../../assets/' + coloredAssetUrls.patientTrash)" class="patientDetailTableIcon" />
              </v-btn>
            </v-hover>
          </td>
        </tr>
      </template>
      <template slot="expanded-item" slot-scope="props">
        <tr>
          <td class="thumb-row-wrapper-td" :colspan="11">
            <patient-exam-image-thumb-row :exam="props.item" />
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PatientExamImageThumbRow from "./PatientExamImageThumbRow";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "PatientDetailTable",
  components: {
    PatientExamImageThumbRow
  },
  data() {
    return {
      headers: [
        {
          id: 1,
          text: "",
          value: "exDict",
          sortable: false
        },
        {
          id: 2,
          text: "",
          value: "exIsStudy",
          sortable: false
        },
        {
          id: 3,
          text: "DATE",
          value: "dateIso"
        },
        {
          id: 4,
          text: "EYE",
          value: "exEye"
        },
        {
          id: 5,
          text: "EXAM TYPE",
          value: "exDevice"
        },
        {
          id: 6,
          text: "PHYSICIAN",
          value: "firstMD",
          class: "d-none d-lg-table-cell"
        },
        {
          id: 7,
          text: "PATHOLOGY",
          value: "exPathology",
          class: "d-none d-lg-table-cell"
        },
        {
          id: 8,
          value: "download",
          sortable: false
        },
        {
          id: 9,
          value: "editExam",
          sortable: false,
          class: this.emrproClass() // need to use method because data is evaluated before the computed
        },
        {
          id: 10,
          value: "delete",
          sortable: false,
          class: this.emrproClass() // need to use method because data is evaluated before the computed
        }
      ],
      sortDesc: true,
      sortBy: "moment",
      expanded: []
    };
  },
  computed: {
    ...mapGetters([
      "patient",
      "ptSrNo",
      "exams",
      "loadingExams",
      "selectedExams",
      "widthXs",
      "widthSm",
      "widthMd",
      "canDelete",
      "canEditPathology",
      "canDownloadExam",
      "ssoEmrPro"
    ]),
    mdOrBelow() {
      return this.widthXs || this.widthSm || this.widthMd;
    }
  },
  methods: {
    ...mapMutations(["selectExams"]),
    selectExam(props) {
      props.select(!props.isSelected);
    },
    emrproClass(){
      return this.$store.getters.enableSavingWithEmrPro ? "" : "d-none-emr-pro";
    }

  },
  watch: {
    ptSrNo() {
      this.expanded = [];
    },
    expanded() {
      this.$store.dispatch("setOpenedExams", this.expanded);
    }
  }
};
</script>

<style lang="scss" scoped>
.patient-detail-wrapper ::v-deep {
  .download {
    padding-left: 4px;
  }
  .delete {
    padding-left: 11px;
  }
  .exambtn {
    height: 20px;
    margin-top: 0px;
    margin-bottom: 0px;

    &:before {
      opacity: 0;
    }
  }

  .pencilIcon {
    margin-left: 10px;
  }

  .thumb-row-wrapper-td {
    padding: 0;
    padding-left: 10px;
  }

  .editable-column {
    cursor: pointer;
  }
  .exam-checkbox {
    .tooltiptext {
      visibility: hidden;
      width: 100px;
      background-color: #616161;
      color: #fff;
      text-align: center;
      border-radius: 6px;

      /* Position the tooltip */
      position: absolute;
      z-index: 1;
    }
    &:hover .tooltiptext {
      visibility: visible;
    }
  }
}

.physicianBlue {
  margin-right: 5px;
}

.phyicianTooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;

  .tooltiptext {
    visibility: hidden;
    width: 200px;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 6px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
  }
  &:hover .tooltiptext {
    visibility: visible;
  }
}
.referringMD {
  color: #afafaf;
}
</style>
